module.exports = __webpack_public_path__ + "static/media/rooftop_guide.fc7ec617.png";